<template>
    <div class="container box-like">
        <div class="button-box">
            <a-button icon="plus" type="primary" @click="onAdd">新建账号</a-button>
            <a-button icon="retweet" @click="onFilterAllReset">重置所有筛选条件</a-button>
        </div>
        <!-- scroll: 页面太小的时候会让表格至少有相应的长度，如果表格项很少就去掉这个，表格项太多的话适当增加 -->
        <a-table :data-source="tableData" :columns="columns" :rowKey="(rec) => rec.id" :scroll="{ x: 600 , y: 66 * 10}" :pagination="pageConfig">
            <!-- slot对应配置文件中customRender的内容 -->
            <div slot="c-type" slot-scope="text">
                <a-switch :checked="Boolean(2 - text)" disabled />
            </div>
            <div slot="c-assoc" slot-scope="text, record">
                <a-popover title="关联用户" trigger="click" :destroyTooltipOnHide="true" @visibleChange="(e) => { if (!e) onInit() }">
                    <div slot="content">
                        <div v-if="record.rolename !== '经销商'">该角色暂不支持关联用户</div>
                        <a-space size="small" direction="vertical" v-else>
                            <a-select style="width: 200px" placeholder="请选择关联用户" mode="multiple" :defaultValue="text.map((s) => s.id)" optionFilterProp="children" @change="(e) => onSelectedSellerChange(e, record.id)">
                                <a-select-option :value="item.id" v-for="(item, index) in sellerList" :key="index">{{item.nickname}}</a-select-option>
                            </a-select>
                            <div style="color: #999999">在框内输入内容可筛选用户名</div>
                        </a-space>
                    </div>
                    <a>点击查看关联用户</a>
                </a-popover>
            </div>
            <div slot="c-action" slot-scope="text, record" style="display: flex;">
                <a-button type="primary" style="margin-right: 4px;" @click="onEdit(record)">编辑</a-button>
                <a-button type="danger" @click="onDelete(record.id)">删除</a-button>
            </div>
            <div slot="filterDropdown" slot-scope="{ confirm, column }" style="padding: 8px">
                <a-input class="filter-input" :placeholder="`搜索${column.title}`" v-model="filterItems[column.filterIndex]" v-if="column.type === 'input'" />
                <a-select class="filter-select" :placeholder="`请选择${column.title}`" :mode="column.multi ? 'multiple' : ''" v-model="filterItems[column.filterIndex]" v-if="column.type === 'select'">
                    <a-select-option :value="item.id" v-for="(item, index) in column.items" :key="index">{{item.name}}</a-select-option>
                </a-select>
                <div>
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="onFilterSearch(confirm)">搜索</a-button>
                    <a-button size="small" icon="retweet" style="width: 90px" @click="onFilterReset(column.filterIndex, confirm)">重置</a-button>
                </div>
            </div>
            <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>

        <a-modal title="编辑信息" :visible="showModal" okText="提交" cancelText="返回" @ok="submit" :maskClosable="false" centered @cancel="showModal = false">
            <a-form-model ref="modelForm" layout="horizontal" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" :model="formModel">
                <a-form-model-item :label="item.title" :prop="`${index}.value`" :rules="item.rules" v-for="(item, index) in formModel" :key="index">
                    <a-input :type="item.aliasType" v-model="item.value" :placeholder="item.placeholder || `请输入${item.title}`" v-if="item.type === 'input'" />
                    <a-select :placeholder="item.placeholder || `请选择${item.title}`" :mode="item.multi ? 'multiple' : ''" v-model="item.value" v-if="item.type === 'select'">
                        <a-select-option :value="item2.id" v-for="(item2, index2) in item.items" :key="index2">{{item2.name}}</a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import {
    stationMap
} from '@/common/project-config'
import {
    formModel,
    columns
} from './manager.conf.js'

export default {
    name: 'admin_manager',
    computed: {
        ...mapState('stored', ['userInfo'])
    },
    data() {
        return {
            // 当前选中的id，只有编辑的时候需要，新增时改为-1
            selectedId: -1,
            // 表格数据
            tableData: [],
            // 显示编辑内容
            showModal: false,
            // 筛选内容
            filterItems: {},
            // 编辑内容配置，在配置文件里
            formModel: { ...formModel },
            // 表格配置，在配置文件里
            columns: [...columns],
            // 分页配置
            pageConfig: {
                current: 1,
                pageSize: 10,
                total: 0,
                pageSizeOptions: ['10', '20', '50', '100', '500'],
                showSizeChanger: true,
                onChange: (a, b) => {
                    this.pageConfig.current = a
                    this.pageConfig.pageSize = b
                    this.onInit()
                },
                onShowSizeChange: (a, b) => {
                    this.pageConfig.current = 1
                    this.pageConfig.pageSize = b
                    this.onInit()
                }
            },
            // 经销商用户列表
            sellerList: []
        }
    },
    created() {

    },
    mounted() {
        this.onInit(true)
    },
    props: {

    },
    watch: {

    },
    methods: {
        ...mapMutations('global', ['setLoading']),
        async onInit(reMap) {
            // 开始loading
            this.setLoading('页面加载中...')
            if (reMap) {
                await this.initMap()
            }
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.admin_manager.get, {
                status: this.userInfo.stationId,
                page: this.pageConfig.current,
                limit: this.pageConfig.pageSize,
                ...this.filterItems
            })
            this.tableData = res.data.data
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data.map((s) => {
                let _s = { ...s }
                _s.status = stationMap[_s.status]
                return _s
            })
            // 其它的逻辑写在这里
            this.pageConfig.total = res.data.total
            // 结束loading
            this.setLoading('')
        },
        async initMap() {
            // 一般情况下，这里写的是选择型的筛选条件的选项，从后端获取
            let res, index
            // 角色列表
            res = await this.$util.request(this.$ctrl.admin_role.get, {
                status: this.userInfo.stationId,
                page: 1,
                limit: 9999
            })
            index = this.columns.findIndex((s) => s.filterIndex === 'role_id')
            this.columns[index].items = this.formModel.role_id.items = res.data.data

            // 经销商列表
            res = await this.$util.request(this.$ctrl.card.getAllCardSeller, {
                status: this.userInfo.stationId,
                rolename: '经销商',
                page: 1,
                limit: 9999
            })
            this.sellerList = res.data
        },
        onFilterSearch(confirm) {
            this.pageConfig.current = 1
            this.onInit()
            confirm()
        },
        onFilterReset(key, confirm) {
            if (this.filterItems.hasOwnProperty(key)) {
                this.filterItems[key] = undefined
                this.pageConfig.current = 1
                this.onInit()
                confirm()
            }
        },
        onFilterAllReset() {
            Object.keys(this.filterItems).forEach((k) => {
                this.filterItems[k] = undefined
            })
            this.pageConfig.current = 1
            this.onInit()
        },
        onSelectedSellerChange(list, id) {
            this.$util.request(this.$ctrl.card.bindSellerAccount, {
                id,
                list
            }).then((res) => {
                if (res.code === 0) {
                    this.$error({
                        title: '提示',
                        content: '修改失败',
                        centered: true
                    })
                }
            })
        },
        onAdd() {
            this.selectedId = -1
            this.showModal = true
            this.$nextTick(() => {
                this.$refs.modelForm.resetFields()
            })
        },
        onEdit(e) {
            this.selectedId = e.id
            this.showModal = true
            this.$nextTick(() => {
                this.$refs.modelForm.resetFields()
                Object.entries(e).forEach(([k, v]) => {
                    if (this.formModel.hasOwnProperty(k)) {
                        this.formModel[k].value = v
                    }
                })
            })
        },
        onDelete(e) {
            this.$confirm({
                title: '提示',
                content: '确定要删除吗？',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.admin_manager.del, {
                        id: e
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '删除成功',
                                centered: true
                            })
                            if (this.tableData.length <= 1 && this.pageConfig.current > 1) {
                                this.pageConfig.current -= 1
                            }
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '删除失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        },
        submit() {
            this.$refs.modelForm.validate((valid) => {
                if (valid) {
                    let modelValues = Object.entries(this.formModel).reduce((p, [k, v]) => {
                        p[k] = v.value
                        return p
                    }, {})
                    this.$util.request(this.$ctrl.admin_manager.edit, {
                        status: this.userInfo.stationId,
                        id: this.selectedId > 0 ? this.selectedId : undefined,
                        ...modelValues
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '提交成功',
                                centered: true
                            })
                            this.showModal = false
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '提交失败',
                                centered: true
                            })
                        }
                    })
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import "./manager.less";
</style>
